import * as Kdata from './K.json';

function Kvalue(input){
  let res;
  let T50 = Kdata.default['Sheet1'].map(x => (x['T50(X)']));
  let K = Kdata.default['Sheet1'].map(x => (x['K(Y)']));
  let index = T50.findIndex(T => T >= input);
  if (T50[index] !== input){
    res = K[index]-(K[index] - K[index - 1]) / (T50[index] - T50[index - 1]) * (T50[index] - input);
  }
  else {
    res = K[index];
  }

  return res
}
export default Kvalue;
